// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IKXrunVg8H80lyFVUHst{padding:0 64px;overflow-x:hidden;overflow-y:auto}.vye13wInCcEo7TnojhZk{flex-direction:column;flex:1;width:100%;max-width:760px;margin:0 auto;padding:0 20px;display:flex}.tmEe_T_OAMIoIbl_kfg4{width:100%;display:flex}.cdcvpW_j2KQx2i54FJCW{flex-direction:column;align-items:center;display:flex}.QuoJYuZph7gV5I_Ye9Mj{border-radius:16px;align-items:flex-end;min-height:276px;margin-bottom:40px;display:flex;overflow:hidden}.QuoJYuZph7gV5I_Ye9Mj img{width:628px;height:auto;display:block}.YZnMMD23QEFQvexXSFMu{text-align:center;max-width:580px;margin-top:4px}.iOgWKyDSsRsuKrdHxezL{text-align:center}.iOgWKyDSsRsuKrdHxezL a{color:var(--content-primary-tertiary);text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IKXrunVg8H80lyFVUHst`,
	"content": `vye13wInCcEo7TnojhZk`,
	"pageHeader": `tmEe_T_OAMIoIbl_kfg4`,
	"title": `cdcvpW_j2KQx2i54FJCW`,
	"previewImageContainer": `QuoJYuZph7gV5I_Ye9Mj`,
	"subTitleText": `YZnMMD23QEFQvexXSFMu`,
	"terms": `iOgWKyDSsRsuKrdHxezL`
};
export default ___CSS_LOADER_EXPORT___;
